import React, { useState, useRef, useEffect } from "react";
import { useLanguage } from "../../../../context/LanguageContext";
import { Globe, ChevronRight, Check } from "lucide-react";
import "./LanguageSwitcher.css";

const LanguageSwitcher = () => {
  const { language, switchLanguage, availableLanguages, getCurrentLanguage } =
    useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentLang = getCurrentLanguage();

  const handleLanguageChange = (langCode) => {
    switchLanguage(langCode);
    setIsOpen(false);
  };

  // close if click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="lang-switcher" ref={dropdownRef}>
      {/* Row trigger like Ounass */}
      <button
        className="lang-row"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <div className="lang-left">
          <Globe size={18} className="lang-icon" />
          <span className="lang-label">Change language</span>
        </div>
        <div className="lang-right">
          <span className="lang-current">{currentLang.nativeName}</span>
          <ChevronRight size={16} className={`chev ${isOpen ? "open" : ""}`} />
        </div>
      </button>

      {/* Elegant dropdown */}
      {isOpen && (
        <div className="lang-dropdown">
          {availableLanguages.map((lang) => {
            const active = language === lang.code;
            return (
              <button
                key={lang.code}
                className={`lang-option ${active ? "active" : ""}`}
                onClick={() => handleLanguageChange(lang.code)}
              >
                <span>{lang.nativeName}</span>
                {active && <Check size={16} className="check" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
